const getPreviewTimeContact = (dateInput) => {
  try {
    const now = new Date();
    const inputDate = new Date(dateInput);

    // Cùng ngày
    if (now.toDateString() === inputDate.toDateString()) {
      return inputDate.toTimeString().slice(0, 5); // hh:mm
    }

    // Hôm qua
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    if (yesterday.toDateString() === inputDate.toDateString()) {
      return "Hôm qua";
    }

    // Từ 2 - 7 ngày trước
    const diffDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const inputDateOnly = new Date(
      inputDate.getFullYear(),
      inputDate.getMonth(),
      inputDate.getDate()
    );

    const diffMs = diffDate - inputDateOnly;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays >= 2 && diffDays <= 7) {
      return `${diffDays} ngày`;
    }

    // Cùng năm
    if (now.getFullYear() === inputDate.getFullYear()) {
      return `${String(inputDate.getDate()).padStart(2, "0")}/${String(
        inputDate.getMonth() + 1
      ).padStart(2, "0")}`; // dd/MM
    }

    // Những năm trước
    return `${String(inputDate.getDate()).padStart(2, "0")}/${String(
      inputDate.getMonth() + 1
    ).padStart(2, "0")}/${inputDate.getFullYear()}`; // dd/MM/yyyy
  } catch {
    return "";
  }
};

const getRelativeTimeContact = (dateInput) => {
  try {
    const now = new Date();
    const inputDate = new Date(dateInput);
    const diffMs = now - inputDate;
    const diffMin = Math.floor(diffMs / 60000);
    const diffHour = Math.floor(diffMs / 3600000);

    if (diffMin < 1) return "Vừa xong";
    if (diffMin < 60) return `${diffMin} phút trước`;
    if (diffHour < 2) return "khoảng 1 giờ trước";
    if (
      diffHour < 24 &&
      now.toDateString() === inputDate.toDateString()
    ) {
      return `${diffHour} giờ trước`;
    }

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    if (yesterday.toDateString() === inputDate.toDateString()) {
      return "Hôm qua";
    }

    const diffDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const inputDateOnly = new Date(
      inputDate.getFullYear(),
      inputDate.getMonth(),
      inputDate.getDate()
    );
    const diffDays = Math.floor((diffDate - inputDateOnly) / 86400000);
    if (diffDays >= 2 && diffDays <= 7) return `${diffDays} ngày trước`;

    const dd = String(inputDate.getDate()).padStart(2, "0");
    const mm = String(inputDate.getMonth() + 1).padStart(2, "0");
    if (now.getFullYear() === inputDate.getFullYear()) return `${dd}/${mm}`;
    return `${dd}/${mm}/${inputDate.getFullYear()}`;
  } catch {
    return "";
  }
};

const getPreviewTimeListMessage = (dateInput) => {
  try {
    const now = new Date();
    const inputDate = new Date(dateInput);

    // Cùng ngày
    if (now.toDateString() === inputDate.toDateString()) {
      return "Hôm nay";
    }

    // Hôm qua
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    if (yesterday.toDateString() === inputDate.toDateString()) {
      return "Hôm qua";
    }

    // Trước đó
    return `${String(inputDate.getDate()).padStart(2, "0")}/${String(
      inputDate.getMonth() + 1
    ).padStart(2, "0")}/${inputDate.getFullYear()}`;
  } catch {
    return "";
  }
};

const getPreviewTimeMessage = (dateInput) => {
  try {
    const inputDate = new Date(dateInput);
    return inputDate.toTimeString().slice(0, 5); // hh:mm
  } catch {
    return "";
  }
};

function replaceGender(content, gender) {
  // Biểu thức chính quy để tìm chuỗi theo mẫu #{SEX{...}}
  return content.replace(/#\{SEX\{([^}]+)\}\}/g, (match, optionsString) => {
    // Tách các lựa chọn bên trong dấu ngoặc nhọn
    const options = optionsString.split("|");

    // Xác định vị trí dựa trên giới tính
    let selectedIndex;
    switch (gender) {
      case 0:
        selectedIndex = 0;
        break;
      case 1:
        selectedIndex = 1;
        break;
      default:
        selectedIndex = 2;
    }

    // Trả về giá trị thay thế nếu có thể, nếu không trả về mặc định
    return options[selectedIndex] || options[options.length - 1];
  });
}

function formatDate(date, format) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Tháng trong JavaScript bắt đầu từ 0
  const year = date.getFullYear();

  return format.replace("DD", day).replace("MM", month).replace("YYYY", year);
}

function replaceDatePlaceholders(content) {
  // Tìm tất cả các chuỗi theo mẫu #{...}
  return content.replace(
    /#\{(TODAY|TOMORROW|YESTERDAY)\((.*?)\)\}/g,
    (match, keyword, format) => {
      let date = new Date();

      switch (keyword) {
        case "TOMORROW":
          date.setDate(date.getDate() + 1);
          break;
        case "YESTERDAY":
          date.setDate(date.getDate() - 1);
          break;
        default:
          break;
      }

      // Định dạng và trả về ngày
      return formatDate(date, format);
    }
  );
}

const urlToBlob = async (imageUrl) => {
  try {
    const response = await fetch(imageUrl);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const blob = await response.blob();

    return blob;
  } catch (error) {
    console.error("Error fetching the image:", error);
  }
};

function normalizeText(input) {
  if (!input) return "";

  const accentsMap = new Map([
    [
      "a",
      /[\u00e0\u00e1\u1ea3\u00e3\u1ea1\u0103\u1eaf\u1eb1\u1eb3\u1eb5\u1eb7\u00e2\u1ea5\u1ea7\u1ea9\u1eab\u1ead]/g,
    ],
    [
      "e",
      /[\u00e8\u00e9\u1ebb\u1ebd\u1eb9\u00ea\u1ebf\u1ec1\u1ec3\u1ec5\u1ec7]/g,
    ],
    ["i", /[\u00ec\u00ed\u1ec9\u0129\u1ecb]/g],
    [
      "o",
      /[\u00f2\u00f3\u1ecf\u00f5\u1ecd\u00f4\u1ed1\u1ed3\u1ed5\u1ed7\u1ed9\u01a1\u1edd\u1edf\u1ee1\u1ee3]/g,
    ],
    ["u", /[\u00f9\u00fa\u1ee7\u0169\u1ee5\u01b0\u1eeb\u1eed\u1eef\u1ef1]/g],
    ["y", /[\u00fd\u1ef3\u1ef7\u1ef9\u1ef5]/g],
    ["d", /[\u0111]/g],
  ]);

  let result = input.toLowerCase();
  accentsMap.forEach((regex, letter) => {
    result = result.replace(regex, letter);
  });

  return result.trim();
}

const removeVietnameseTones = (str) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  return str;
};

const common = {
  getPreviewTimeContact,
  getRelativeTimeContact,
  getPreviewTimeListMessage,
  getPreviewTimeMessage,
  replaceGender,
  replaceDatePlaceholders,
  urlToBlob,
  normalizeText,
  removeVietnameseTones
};

export default common;
